import triggerAlert from "./alert.js"
import handleChange from "./change.js"
import { handleLoader } from "./loader.js"
import handleProgress from "./progress.js"
import renderOrderData from "./review.js"
import { scrollToTop } from "./scroll.js"
import handleSections from "./sections.js"
import updateName from "./updateName.js"
import syncWeightInputs from './updateWeight'

const wizard = document.querySelector(".shopify-section-quiz-wizard");
if (!wizard) return;

// Order data
const orderData = {
  name: {
    question: "Your dogs name is",
    answer: "",
  },
  breed: {
    question: "Marley's breed is a",
    answer: "",
  },
  gender: {
    question: "Marley is a",
    answer: "",
  },
  neutered: {
    question: "Is Marley Neutered",
    answer: "",
  },
  years: {
    question: "How old is Marley in years",
    answer: "",
  },
  months: {
    question: "How old is Marley in months",
    answer: "",
  },
  weight: {
    question: "Marley weights approximately",
    answer: "",
  },
  size: {
    question: "Marley is",
    answer: "Normal weight",
  },
  activity: {
    question: "Marley is",
    answer: "Normal activity",
  },
  allergies: {
    question: "Marley is allergic to",
    answer: [],
  },
  treats: {
    question: "Marley gets treats",
    answer: "Sometimes",
  },
  eating: {
    question: "Marley is currently eating",
    answer: [],
  },
  health_issues: {
    question: "Health issues",
    answer: [],
  },
  fussy_dog: {
    question: "Is Marley a real fussy dog that would turn its nose up at a filet mignon?",
    answer: "",
  },
  prefered_treat: {
    question: "Prefered treat",
    answer: [],
  },


  plan: {
    question: "Marley's plan",
    answer: "",
    contents: "",
  },
  owner_name: {
    question: "Your name",
    answer: "",
  },
  owner_email: {
    question: "Your email",
    answer: "",
  },
  owner_mobile: {
    question: "Mobile",
    answer: "",
  },
};


// Navigate with enter key
jQuery(window).keydown(function (e) {
  if (e.keyCode == 13) {
    e.preventDefault();
    jQuery('input[type=text], textarea').blur();
    if (document.querySelector('.wizard-v2').dataset.current == 16) {
      jQuery('.next__button.trigger-post-quiz').trigger('click');
    } else {
      jQuery('.next__button:not(.trigger-post-quiz)').trigger('click');
    }
    return false;
  }
});


// Add active state to wizard "Another dog" text
jQuery('.wizard__another_dog h3').on('click', function (e) {
  e.preventDefault();
  jQuery('.wizard__another_dog div.another_dog_info').slideToggle();
});


// Handle order data change
document.querySelectorAll("[data-order]").forEach(input => {
  input.addEventListener("change", event => handleChange(event, orderData));
});


// Buttons
const nextButton = document.querySelector(".next__button");
const startButton = document.querySelector(".start__button");
const checkoutButton = document.querySelector(".checkout__button");
const skipButton = document.querySelector(".skip__button");
const backButton = document.querySelector(".back__button");
const reviewButton = document.querySelector(".review__button");


// Variables
let step = 1;
let price = 0;
let running = false;
let hasReviewed = false;
let couponUsage = false;
let flkty = false;
let sliderItems = false;
let isPuppy = true;
const trial = document.querySelector('.wizard-v2').dataset.trial == 'true' ? true : false;
const trialCartons = 4;
let wpDays = trial ? 28 : 14;

function getTrialEndDate() {
  const date = new Date();
  date.setDate(date.getDate() + 14);
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}


// Confirm navigation
window.onbeforeunload = function () { return true; };


// Puppy modals listeners
jQuery('input[data-order="years"]').on('input', function () {
  var months = Number(jQuery('input[data-order="years"]').val()) * 12 + Number(jQuery('input[data-order="months"]').val());
  puppyModalHelper(months);
});

jQuery('input[data-order="months"]').on('input', function () {
  var months = Number(jQuery('input[data-order="years"]').val()) * 12 + Number(jQuery('input[data-order="months"]').val());
  puppyModalHelper(months);
});


// Switch between neutered/spayed
jQuery('input[type="radio"][name="gender"]').on('change', function () {
  var selection = jQuery('input[type="radio"][name="gender"]:checked').val();
  var label = document.getElementById('neutered-spayed');
  var button = document.querySelector('.wizard-v2[data-current="3"] .regular-quiz-flow span');
  var old = label.innerHTML;
  let dog_sex = $('.gender-update');
  label.innerHTML = (selection == 'Boy') ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
  dog_sex.html((selection == 'Boy') ? "he" : "she");
  if (button) {
    button.innerHTML = (selection == 'Boy') ? button.innerHTML.replace('Spayed', 'Neutered') : button.innerHTML.replace('Neutered', 'Spayed');
  }

  jQuery('#neutered-spayed-container').show();

});





// Age input switch
jQuery('.inputChoices a[data-switcher="manual"]').on('click', function () {
  jQuery(this).attr('class', 'active');
  jQuery('.inputChoices a[data-switcher="datepicker"]').attr('class', '');
  jQuery('.inputSwitch#inputManual').css('display', 'block');
  jQuery('.inputSwitch#inputDatepicker').css('display', 'none');
});

jQuery('.inputChoices a[data-switcher="datepicker"]').on('click', function () {
  jQuery(this).attr('class', 'active');
  jQuery('.inputChoices a[data-switcher="manual"]').attr('class', '');
  jQuery('.inputSwitch#inputManual').css('display', 'none');
  jQuery('.inputSwitch#inputDatepicker').css('display', 'block');
});


// Slider illustrations
// jQuery('input[type="range"]').on('input change', function() {
//   var path = '/wp-content/themes/marleybones/assets/images/slider/';
//   if (this.name == 'weightgroup') { jQuery('img[data-slider="weightgroup"').attr('src', path+'size-0'+this.value+'.svg'); }
//   if (this.name == 'activity') { jQuery('img[data-slider="activity"').attr('src', path+'active-0'+this.value+'.svg'); }
//   if (this.name == 'treats') { jQuery('img[data-slider="treats"').attr('src', path+'treat-0'+this.value+'.svg'); }
// });


// Validate required inputs
function validate(target) {

  let errors = false;
  let customError = false;

  // Reset label styling
  jQuery('section[data-step="' + target + '"] label').each(function (i, obj) { jQuery(this).css('color', '#0f4632'); });

  // Validate required inputs
  let invalidInputs = jQuery('section[data-step="' + target + '"] input[required]:invalid');
  if (invalidInputs.length > 0) {
    invalidInputs.each(function (i, obj) { jQuery('label[for="' + jQuery(this).attr('name') + '"]').css('color', '#ac2227'); });
    errors = true;
  }

  // Validate radio buttons
  let numRadio = jQuery('section[data-step="' + target + '"] .radio__select');
  numRadio.each(function (i, obj) {
    if (jQuery(this).find('input[type="radio"]:checked').length == 0) {
      jQuery(this).siblings('label').css('color', '#ac2227');
      errors = true;
    }
  });

  // Validate checkboxes
  let multiselect = jQuery('section[data-step="' + target + '"] .multiselect__container');
  multiselect.each(function (i, obj) {
    if (jQuery(this).find('input[type="checkbox"]:checked').length == 0) {
      jQuery(this).prev('label').css('color', '#ac2227');
      errors = true;
    }
    if (jQuery(this).data('contains') == 'allergies' && jQuery(this).find('input[type="checkbox"]:checked').length == 4) {
      jQuery(this).prev('label').css('color', '#ac2227');
      errors = true;
      customError = 'Oh no! Looks like ' + orderData["name"]["answer"] + ' is allergic to all variants. Please get in touch if you have any questions';
    }
  });

  let healthselect = jQuery('section[data-step="' + target + '"] .health__container');
  healthselect.each(function (i, obj) {
    if (jQuery(this).find('input[type="checkbox"]:checked').length == 0) {
      jQuery(this).prev('label').css('color', '#ac2227');
      errors = true;
    }
  });

  if (errors) {
    if (customError) { triggerAlert(customError); }
    else { triggerAlert(); }
    return false;
  }

  return true;

}

// Handle package slider
const handleSlider = () => {

  flkty = new Flickity(".meal__slider", {
    cellSelector: '.valid-cell',
    cellAlign: "left",
    pageDots: false,
    prevNextButtons: true,
  });

  // Activate prev/next button when selecting cards. The buttons are hidden in flickity.css
  jQuery('#flickity-left').on('click', function () { document.querySelector('button.flickity-prev-next-button.previous').click(); });
  jQuery('#flickity-right').on('click', function () { document.querySelector('button.flickity-prev-next-button.next').click(); });

  flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
    flkty.select(cellIndex, false, false);
  });

  flkty.on("select", function (index) {

    var cellElement = (flkty.getCellElements())[index];

    document.querySelectorAll(".meal__sliderItem").forEach(item => {
      if (item !== cellElement) {
        item.classList.remove("select");
      }
    });

    // Mark as selected
    cellElement.classList.add("select");
    //document.querySelector('input[name="product"]').value = cellElement.getAttribute("data-product");

    // Ensure visible price breakdown
    document.querySelector('.price__breakdown').style.display = 'block';

    // If trial box is selected
    var isTrial = false;
    if (cellElement.getAttribute("data-product") == 'trial') {
      isTrial = true;

      orderData["plan"]["answer"] = 'Trial box';

      //document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';
      //document.querySelector('.price__breakdown tr[data-content="mealplan"]').style.display = 'none';
      //document.querySelector('.price__breakdown .billing-cycle').style.display = 'none';
      //document.querySelector('.price__breakdown .discount-duration').style.display = 'none';

      //document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = '£18.00';
      //document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = '£3.00';

    }/* else {*/

    if (cellElement.getAttribute("data-product") == '100') { orderData["plan"]["answer"] = 'Full plan'; }
    if (cellElement.getAttribute("data-product") == '60') { orderData["plan"]["answer"] = 'Mixed plan'; }

    //document.querySelector('.price__breakdown tr[data-content="mealplan"]').style.display = 'block';
    document.querySelector('.price__breakdown .billing-cycle').style.display = 'block';
    document.querySelector('.price__breakdown .discount-duration').style.display = 'block';

    // Price breakdown
    var packageTotal = parseFloat(cellElement.getAttribute('data-total'));
    var packageBefore = parseFloat(cellElement.getAttribute('data-before'));
    var packageVat = parseFloat(cellElement.getAttribute('data-vat'));

    if (packageBefore > 0) {

      document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'block';

      var dailyString = '<del>£' + (packageBefore / 28).toFixed(2) + '</del>&nbsp; £' + (packageTotal / 28).toFixed(2) + ' /day';
      var totalString = '<del>£' + packageBefore.toFixed(2) + '</del>&nbsp; £' + packageTotal.toFixed(2);

      document.querySelector('.price__breakdown tr[data-content="discount"] .value').innerHTML = '-£' + (packageBefore - packageTotal).toFixed(2);

      if (couponUsage) {
        if (couponUsage > 1) {
          document.querySelector('.price__breakdown label small').innerHTML = 'The applied coupon is valid for the first ' + couponUsage + ' boxes';
        }
        else {
          document.querySelector('.price__breakdown label small').innerHTML = 'The applied coupon is valid for the first box';
        }
      }

    } else {

      var dailyString = '£' + (packageTotal / 28).toFixed(2) + ' /day';
      var totalString = '£' + packageTotal.toFixed(2);

      document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';

    }

    if (isTrial) {
      document.querySelector('.price__breakdown .billing-cycle').style.display = 'none';
      //document.querySelector('.price__breakdown tr[data-content="mealplan"]').style.display = 'none';
    }

    //document.querySelector('.price__breakdown tr[data-content="mealplan"] .value').innerHTML = dailyString;
    document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = totalString;
    document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = '£' + packageVat.toFixed(2);

    //}

    if (orderData["plan"]["answer"]) {
      nextButton.classList.remove("disabled");
      nextButton.innerHTML = 'Checkout';
    }

  });

  flkty.select(0, false, false);

}

// Review choices
reviewButton?.addEventListener("click", () => {
  renderOrderData(reviewButton, orderData)
  hasReviewed = true
});

// Close review
jQuery('.review__button.close').on('click', function () {
  reviewButton.innerHTML = 'Review your choices';
  jQuery(this).css('display', 'none');
});


// Get input values
function qiv(name) {
  var element = document.querySelector('form input[name="' + name + '"]');
  return (element || element === 0) ? element.value : false;
}

// Get age values
function ageInput(type) {
  if (type == 'years') { return parseInt(qiv('years')) || 0; }
  if (type == 'months') { return parseInt(qiv('months')) || 0; }
  //if (type == 'birthday') { return (inputType == 'manual') ? false : qiv('datepicker__input'); }
}

let dogName = "Marley";

function getInput() {
  return {
    name: qiv('dog_name'),
    breed: (document.querySelector('form input[name="breed"]:checked')?.value == "unknown_breed") ? 'Pawfect mix' : qiv('breed__autocomplete'),
    gender: document.querySelector('form input[name="gender"]:checked')?.value,
    neutered: document.querySelector('form input[name="neutered"]:checked')?.value,
    years: ageInput('years'),
    months: ageInput('months'),
    //birthday: ageInput('birthday'),
    weight: parseFloat(qiv('weight')),
    weightgroup: parseInt(document.querySelector('input[name="weightgroup"]:checked')?.value),
    activity: parseInt(document.querySelector('input[name="activity"]:checked')?.value),
    treats: parseInt(document.querySelector('input[name="treats"]:checked')?.value),
    allergies: jQuery('form input[name="allergies"]:checked')?.map(function () { return jQuery(this).val().toLowerCase(); }).get(),
    food: jQuery('form input[name="current__food"]:checked')?.map(function () { return jQuery(this).val().toLowerCase(); }).get(),
    health_issues: jQuery('form input[name="health_issues"]:checked')?.map(function () { return jQuery(this).val().toLowerCase(); }).get(),
    fussy_dog: document.querySelector('form input[name="fussy_dog"]:checked')?.value,
    prefered_treat: jQuery('form input[name="prefered_treat"]:checked')?.map(function () { return jQuery(this).val().toLowerCase(); }).get(),
  };
}


// Limit modal
var limitModal = document.querySelector('.limit-modal');

limitModal.querySelector('.close').addEventListener("click", function () { limitModal.style.display = 'none'; });

function limitModalHelper() {
  var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
  limitModal.style.marginTop = top + 'px';
  limitModal.style.display = 'inline-block';
}


// Pawrent login
var loginAction = 'create';

jQuery('.pawrent-welcome .pawrent-switch').on('click', function (e) {
  loggedIn = false;
  loginAction = 'login';
  jQuery('.pawrent-welcome').css('display', 'none');
  jQuery('.pawrent-login').css('display', 'block');
});

jQuery('.pawrent-login .new-account').on('click', function (e) {
  loginAction = 'create';
  jQuery('.pawrent-login').css('display', 'none');
  jQuery('.pawrent-register').css('display', 'block');
});

jQuery('.pawrent-register .existing-account').on('click', function (e) {
  loginAction = 'login';
  jQuery('.pawrent-login').css('display', 'block');
  jQuery('.pawrent-register').css('display', 'none');
});

function loginError(message) {
  running = false;
  nextButton.textContent = 'Next';
  triggerAlert(message);
  return false;
}

// function handleLogin() {

//   if (loggedIn) {

//     // OrderData: Ensure correct name and email
//     orderData["owner_name"]["answer"] = loggedInName;
//     orderData["owner_email"]["answer"] = loggedInEmail;

//     handleCoupon();
//     return;

//   }

//   if (loginAction == 'login') { // Perform login

//       // Validate input
//       let email = document.querySelector('.pawrent-login input[name="owner_email"]').value;
//       let password = document.querySelector('.pawrent-login input[name="owner_password"]').value;

//       if (!/\S+@\S+\.\S+/.test(email)) { return loginError('Please type in a valid email address'); }
//       if (password.length <= 3) { return loginError('Please type in a valid password'); }

//       // Sign in
//       jQuery.ajax({
//         url: "/wp-admin/admin-ajax.php",
//         async: true,
//         data: {
//           action: 'marleybones_handle_user',
//           handle: 'login',
//           email: email,
//           password: password,
//           newsletter: document.querySelector('.pawrent-login input[name="mc_signup"]').checked
//         },
//         type: 'post',
//         success: function(res) { 
//           if (res.status == true) {

//             // OrderData: Ensure correct name and email
//             orderData["owner_name"]["answer"] = res.name;
//             orderData["owner_email"]["answer"] = email;

//             // Change to "welcome back" screen
//             loggedIn = true;
//             loggedInName = orderData["owner_name"]["answer"];
//             loggedInEmail = orderData["owner_email"]["answer"];
//             jQuery('.pawrent-welcome .welcome-text').text('Welcome back, '+orderData["owner_name"]["answer"]);
//             jQuery('.pawrent-login').css('display', 'none');
//             jQuery('.pawrent-register').css('display', 'none');
//             jQuery('.pawrent-welcome').css('display', 'block');

//             // Enable/disable trialbox
//             if (res.trialbox_status != false) {
//               jQuery('.packages .trial').css('display', 'none');
//             } else {
//               jQuery('.packages .trial').css('display', 'block');
//             }

//             // Proceed
//             handleCoupon();
//             return;

//           } else {

//             if (res.error) {
//               return loginError(res.error);
//             } else {
//               return loginError('An error occurred while trying to log you in');
//             }

//           }
//         },
//         error: function(em) { return loginError(false); }
//       });

//   } else { // Create account

//     // Validate input
//     let name = document.querySelector('.pawrent-register input[name="owner_name"]').value;
//     let email = document.querySelector('.pawrent-register input[name="owner_email"]').value;
//     let password = document.querySelector('.pawrent-register input[name="owner_password"]').value;
//     let password_repeat = document.querySelector('.pawrent-register input[name="owner_password_repeat"]').value;

//     if (name.length < 5) { return loginError('Please type in a valid name'); }
//     if (!/\S+@\S+\.\S+/.test(email)) { return loginError('Please type in a valid email address'); }
//     if (password.length <= 3) { return loginError('Please type in a valid password'); }
//     if (password !== password_repeat) { return loginError('Passwords must match'); }

//     // Check email
//     jQuery.ajax({
//       url: "/wp-admin/admin-ajax.php",
//       async: true,
//       data: {
//         action: 'marleybones_handle_user',
//         handle: 'check',
//         email: document.querySelector('.pawrent-register input[name="owner_email"]').value
//       },
//       type: 'post',
//       success: function(res) {

//         if (res.status !== true) {

//           return loginError('That email address is already in use');

//         } else {
// 					console.log('creatr account');
//           createAccount();
//           return;

//         }

//       },
//       error: function(err) { return loginError('An error occurred'); }
//     });

//   }

// }

// function createAccount() {

// 	console.log(get_phone());


//   jQuery.ajax({
//     url: "/wp-admin/admin-ajax.php",
//     async: true,
//     data: {
//       action: 'marleybones_handle_user',
//       handle: 'create',
//       name: document.querySelector('.pawrent-register input[name="owner_name"]').value,
//       email: document.querySelector('.pawrent-register input[name="owner_email"]').value,
//       password: document.querySelector('.pawrent-register input[name="owner_password"]').value,
//       newsletter: document.querySelector('.pawrent-register input[name="mc_signup"]').checked,
//       phone: get_phone(),
//     },
//     type: 'post',
//     success: function(res) {

//       if (res.status !== true) {

//         return loginError('An error occurred while trying to create your account');

//       } else {

//         // OrderData: Ensure correct name and email
//         orderData["owner_name"]["answer"] = document.querySelector('.pawrent-register input[name="owner_name"]').value;
//         orderData["owner_email"]["answer"] = document.querySelector('.pawrent-register input[name="owner_email"]').value;

//         // Change to "welcome back" screen
//         loggedIn = true;
//         loggedInName = orderData["owner_name"]["answer"];
//         loggedInEmail = orderData["owner_email"]["answer"];
//         jQuery('.pawrent-welcome .welcome-text').text('Welcome back, '+orderData["owner_name"]["answer"]);
//         jQuery('.pawrent-login').css('display', 'none');
//         jQuery('.pawrent-register').css('display', 'none');
//         jQuery('.pawrent-welcome').css('display', 'block');

//         // Ensure that trialbox is visible
//         jQuery('.packages .trial').css('display', 'block');

//         if(document.querySelector('.pawrent-register input[name="mc_signup"]').checked) {
// 					const options = {
// 						method: 'POST',
// 						headers: {revision: '2023-06-15', 'content-type': 'application/json'},
// 						body: JSON.stringify({
// 							data: {
// 								type: 'subscription',
// 								attributes: {
// 									list_id: 'XWKRtA',
// 									custom_source: 'Wizard',
// 									email: document.querySelector('.pawrent-register input[name="owner_email"]').value,
// 									phone_number: get_phone()
// 								}
// 							}
// 						})
// 					};

// 					fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R6vSRF', options)
// 						.then(response => response.json())
// 						.then(response => console.log(response))
// 						.catch(err => console.error(err));
// 				}


//         // Proceed
//         handleCoupon();
//         return;

//       }

//     },
//     error: function(err) { return loginError('An error occurred'); }
//   });

// }

let discountCodeValue = 0;
let discountCode;

function handleCoupon() {

  // Check coupon-code
  let coupon = document.querySelector('form input[name="discount"]').value;
  let havecoupon = document.querySelector('form input[name="have_discount"]').checked;

  if (havecoupon !== false && coupon.length >= 3) {

    let ccode = JSON.stringify(coupon);
    let store = Shopify.shop;

    // Handle coupon
    jQuery.ajax({
      url: `https://netlify.blacklemon.dk/.netlify/functions/checkCouponCode?store=${store}`,
      async: true,
      data: {
        ccode
      },
      type: 'post',
      success: function (res) {

        let response = JSON.parse(res);

        if (response.error) {
          console.log('we have error');
          document.querySelector('.coupon-status').classList.remove('coupon-status--active');
          document.querySelector('.coupon-status').classList.add('coupon-status--error');
          $('.post-wizard-recommendation__info-discount-wrapper').hide();
          discountCode = "";
        } else {
          discountCodeValue = response.success / 100;
          document.querySelector('.coupon-status').classList.add('coupon-status--active');
          document.querySelector('.coupon-status').classList.remove('coupon-status--error');
          document.querySelector('.coupon-status_message--valid span').innerHTML = response.success;
          $('.package-original-price').addClass('package-original-price--crossed');
          $('.post-wizard-recommendation__info-discount-wrapper').show();
          discountCode = coupon;
        }

        // needs 

      },
      error: function (err) { triggerAlert('An error occurred'); return; }
    });

  } else if (havecoupon !== false && coupon.length <= 3) {

    return loginError('Invalid coupon code!');

  } else {

    // loginProceed();
    return;

  }

}

function loginProceed() {

  handleLoader();
  navigate('next');
  //checkoutFlow(16);

  running = false;
  nextButton.textContent = 'Next';
  var variants = ['chicken', 'beef', 'lamb', 'salmon'];
  var hundred = { status: false };
  var sixty = { status: false };


  var dailyIntake = document.querySelector(".daily-intake").innerHTML;

  var breedInput = (document.querySelector('form input[name="unknown_breed"]').checked == true) ? '' : qiv('breed__autocomplete');
  var sizeInput = orderData["size"]["answer"];
  var dogName = document.querySelector('input[name="dog_name"]').value;

  console.log(orderData["size"]["answer"]);
  console.log(orderData["size"]);
  console.log(sizeInput);


  if (typeof sizeInput === 'string' || sizeInput instanceof String) {
    //everything fine
  }
  else {
    sizeInput = sizeInput['weight'];
  }

  dailyIntake = dailyIntake.replace('{dogname}', dogName);
  dailyIntake = dailyIntake.replace('{years}', orderData["years"]["answer"]);
  dailyIntake = dailyIntake.replace('{breed}', breedInput.toLowerCase());
  dailyIntake = dailyIntake.replace('{size}', sizeInput.toLowerCase());
  //document.querySelector(".daily-intake").innerHTML = dailyIntake;

  var ageStr = '';
  if (orderData["years"]["answer"] != '' && orderData["years"]["answer"] != 0) {
    if (orderData["years"]["answer"] == 1) {
      ageStr = orderData["years"]["answer"] + ' year ';
    }
    else {
      ageStr = orderData["years"]["answer"] + ' years ';
    }
  }

  if (orderData["months"]["answer"] != '' && orderData["months"]["answer"] != 0) {
    if (orderData["months"]["answer"] == 1) {
      ageStr = ageStr + orderData["months"]["answer"] + ' month ';
    }
    else {
      ageStr = ageStr + orderData["months"]["answer"] + ' months ';
    }
  }

  if (ageStr != '') {
    ageStr = ageStr + ' old';
  }

  document.querySelector(".daily-intake output.name").innerHTML = dogName;
  document.querySelector(".daily-intake output.breed").innerHTML = breedInput.toLowerCase();
  document.querySelector(".daily-intake output.size").innerHTML = sizeInput.toLowerCase();
  document.querySelector(".daily-intake output.age").innerHTML = ageStr;

  jQuery('#package-selector .tabs').tabs();

  // Create packages
  [100, 'trial'].forEach((percent, index) => {
    jQuery.ajax({
      url: "/wp-admin/admin-ajax.php",
      async: true,
      data: {
        action: 'marleybones_fetch_package',
        input: getInput(),
        percentage: percent
      },
      type: 'post',
      success: function (res) {

        // First run
        if (!hundred.status && !sixty.status) {
          if (percent != 'trial') {
            var meals = res.dailyMeals.toString().replace('.25', '&frac14;').replace('.5', '&frac12;').replace('.75', '&frac34;').replace('0', '');
            //document.querySelector('.daily-intake span').innerHTML = meals + ' pack per day ('+res.dailyKcal+' kcal)'; 

            var mealsCount = (res.dailyMeals * 28);
            mealsCount = (mealsCount < 14) ? 14 : mealsCount;
            jQuery(".package-count span").html(mealsCount);

          }
          if (Number(res.coupon_usage_limit) > 0) {
            couponUsage = Number(res.coupon_usage_limit);
            console.log('Coupon usage: ' + couponUsage);
            var couponUsageTxt = 'The applied coupon is valid for the first box';
            if (couponUsage > 1) {
              couponUsageTxt = 'The applied coupon is valid for the first ' + couponUsage + ' boxes';
            }
            document.querySelector('.price__breakdown .discount-duration small').innerHTML = couponUsageTxt;


          }

        }

        // Count products
        var products = 0;
        jQuery.each(variants, function (i, v) {
          products = products + res.package_js[v];
        });

        var isTrial = (res.percentage == 'trial') ? true : false;

        var dailyString = '£' + (res.total / 28).toFixed(2) + ' /day';
        var totalString = '£' + res.total.toFixed(2);

        console.log(res);

        if (products >= 14 || isTrial) {

          //document.querySelector('.package[data-product="'+percent+'"]').className = 'meal__sliderItem package valid-cell';

          // If discounted
          if (Number(res.before) > 0) {

            if (isTrial) {
              var dailyString = '<del>£' + (res.before).toFixed(2) + '</del>&nbsp; £' + (res.total).toFixed(2);
              var totalString = '<del>£' + res.before.toFixed(2) + '</del>&nbsp; £' + res.total.toFixed(2);
            }
            else {
              var dailyString = '<del>£' + (res.before / 28).toFixed(2) + '</del>&nbsp; £' + (res.total / 28).toFixed(2) + ' /day';
              var totalString = '<del>£' + res.before.toFixed(2) + '</del>&nbsp; £' + res.total.toFixed(2);
            }
            document.querySelector('.price__breakdown tr[data-content="discount"] .value').innerHTML = '-£' + (res.before - res.total).toFixed(2);

          } else {
            if (isTrial) {
              var dailyString = '£' + (res.total).toFixed(2);
              var totalString = '£' + res.total.toFixed(2);
            }
            else {
              var dailyString = '£' + (res.total / 28).toFixed(2) + ' /day';
              var totalString = '£' + res.total.toFixed(2) + ' /month';
            }
            document.querySelector('.price__breakdown tr[data-content="discount"]').style.display = 'none';

          }

          jQuery('li[data-product=' + percent + '] span').html(dailyString);

          /*
            document.querySelector('.package[data-product="'+percent+'"] .price').innerHTML = dailyString;
            if(!isTrial) {
              document.querySelector('.package[data-product="'+percent+'"] .packs span').innerHTML = (res.dailyMeals.toString()).replace('.25', '&frac14;').replace('.5', '&frac12;').replace('.75', '&frac34;').replace('0', '') + ' ' + ((res.dailyMeals == 1) ? 'pack' : 'packs');
              //document.querySelector('.package[data-product="'+percent+'"] .dinings span').innerHTML = parseFloat(res.dailyMeals) * 4;
            }
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-total', res.total);
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-before', res.before);
            document.querySelector('.package[data-product="'+percent+'"]').setAttribute('data-vat', res.vat);
  
  */
          // Insert package products
          var packageTable = '';
          // if(!isTrial) {
          var sorted = Object.keys(res.package_js).sort(function (a, b) { return res.package_js[b] - res.package_js[a]; });
          var totalPacks = 0;
          jQuery.each(sorted, function (i, v) {
            //if (variants.indexOf(v) == -1) { return; }
            if (res.package_js[v] < 1) {
              packageTable += '<div class="hide" data-product-teaser="' + v + '"><img style="width: 100%;" src="' + res.prodimages[v] + '" /> <span>' + res.package_js[v] + '</span>x ' + v + '</div>';
            } else {
              packageTable += '<div data-product-teaser="' + v + '"><img style="width: 100%;" src="' + res.prodimages[v] + '" /> <span>' + res.package_js[v] + '</span>x ' + v + '</div>';
            }

            if (percent != 'trial') {
              jQuery("#plan_quantity_" + v).val(res.package_js[v]);
              console.log("Setting " + v + " to " + res.package_js[v]);
              totalPacks += res.package_js[v];
              jQuery("#plan_quantity_" + v).trigger('change');
            }
            else {
              jQuery("#trial_quantity_" + v).val(res.package_js[v]);
              jQuery("#trial_quantity_" + v).trigger('change');
            }
          });
          if (percent != 'trial') {
            jQuery("#package").val(totalPacks);
            jQuery("#package").trigger('change');

            //Add trialbox
          }
          if (orderData["prefered_treat"]["answer"] != '' && orderData["prefered_treat"]["answer"] != 'none') {
            packageTable = packageTable + '<div><img style="width: 100%;" src="/wp-content/themes/marleybones/assets/images/' + orderData["prefered_treat"]["answer"] + '_treats.png"> Free treats for life</div>';
          }
          document.querySelector('.package-tab[data-product="' + percent + '"] .package-items').innerHTML = packageTable;
          //}
        }
        else {
          if (percent == 100) {
            navigate('back');
            nextButton.textContent = 'Next';
            limitModalHelper();
            return;
          }

        }

        // Register 100% run
        /*if (percent == 100) { 
          hundred.status = true; 
          hundred.price = res.total;
          hundred.products = products;
          document.querySelector('.packages .best-value').style.display = 'block';
        }

        // Register 60% run
        if (percent == 60) { 
          sixty.status = true; 
          sixty.price = res.total;
          sixty.products = products;
        }

        // Last run
        if (hundred.status && sixty.status) {

          // Hide 60% if price is too close to 100%
          if (hundred.price > 0 && sixty.price > 0 && hundred.price < (sixty.price+3)) {
            document.querySelector('.package[data-product="60"]').className = 'meal__sliderItem package';
            document.querySelector('.package[data-product="100"] .best-value').style.display = 'none';
          }

          // Initiate flickity
          //setTimeout(() => handleSlider(), 100); 
          //console.log('Flickity initiated');

        }*/

        // 100% package
        if (percent == 100) {

          // Show default price breakdown
          document.querySelector('.price__breakdown').style.display = 'block';
          //document.querySelector('.price__breakdown tr[data-content="mealplan"] .value').innerHTML = dailyString;
          document.querySelector('.price__breakdown tr[data-content="total"] .value').innerHTML = totalString;
          //document.querySelector('.price__breakdown tr[data-content="vat"] .value').innerHTML = '£'+res.vat.toFixed(2);

        }

      },
      error: function (err) { triggerAlert('An error occurred'); return; }
    });
  });

}



function handleCheckout() {

  // Handle attempts
  checkoutAttempts = checkoutAttempts + 1;

  if (checkoutAttempts <= 5) {

    console.log(checkoutAttempts + '. Attempt...');

    console.log(getInput());

    var activeProduct = document.querySelector('input[name="product"]').value;
    if (activeProduct == '') { activeProduct = 'trial'; }
    var mealQuantity = {};
    var extraQuantity = {};

    jQuery('.mealquantity.plan-' + activeProduct).each(function () {
      mealQuantity[jQuery(this).attr('data-product-id')] = jQuery(this).val();
    });
    jQuery('.extraquantity').each(function () {
      extraQuantity[jQuery(this).attr('data-product-id')] = jQuery(this).val();
    });

    console.log(mealQuantity);
    console.log(extraQuantity);


    // Add to cart
    jQuery.ajax({
      url: "/wp-admin/admin-ajax.php",
      async: true,
      data: {
        action: 'marleybones_add_to_cart',
        percentage: activeProduct,
        quantity_meals: mealQuantity,
        quantity_extras: extraQuantity,
        input: getInput()
      },
      type: 'post',
      success: function (res) {

        if (res.status == true) {

          // Redirect to checkout
          console.log(res);
          window.onbeforeunload = null;
          window.location.href = "/checkout";

        } else {
          console.log(res);
          console.log('Failed (status false)');
          handleCheckout();

        }

      },
      error: function (err) {

        console.log('Failed (AJAX error)');
        handleCheckout();

      }
    });

  } else {

    triggerAlert('Checkout failed. Please try again or contact us');
    return;

  }

}

// Checkout flow tracking
function checkoutFlow(step) {

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'checkout',
    'ecommerce': {
      'checkout': {
        'actionField': {
          'step': step
        }
      }
    }
  });

}

// Track first step on load
checkoutFlow(1);

let monthlyCartons;
let cartObject;
let cartTrialObject;
let cartHalfObject;


// Handle steps
function navigate(click) {
  // Handle navigation
  step = (click == 'back') ? step - 1 : step + 1;

  document.querySelector('.progress__counter span').innerHTML = step - 1;
  document.querySelector('.next__button span').innerHTML = document.querySelector(`section[data-step='${step + 1}']`)?.dataset.topic;

  updateName();
  dogName = qiv('dog_name');

  handleProgress(click, step);
  handleSections(step);
  scrollToTop();

  document.querySelector('.wizard-v2').dataset.current = step;

  if (step === 1) {
    checkoutFlow(1);
  }

}

function handleSteps() {

  let next = step + 1;
  if (step > 1) {
    saveQuizProgress(step);
  }

  // Proceed from dog name and apply it to labels

  if (next === 2) {
    if (validate(step)) {
      navigate('next');
      backButton.classList.remove("disabled");
      // startButton.classList.add("disabled");
      nextButton.classList.remove("disabled");
      checkoutFlow(next);
    }

  }

  if (next === 3) {
    /* if (!ageInput('years') && !ageInput('months') && !ageInput('birthday')) {
       triggerAlert('Please fill out the age of your pooch');
     } else {
       if (validate(step)) {
         if (ageAllowed) {
           navigate('next');
           checkoutFlow(next);
         } else {
           triggerAlert('Whoops, seems like you\'ve exceeded the age limit. Are you sure that your dog is that old?');
         }
       }
     }*/

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }

  if (next === 4) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 5) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }

  // Go to login
  if (next === 6) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 7) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 8) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 9) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 10) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 11) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 12) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }

  if (next === 13) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 14) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }
  if (next === 15) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

  }

  // Coupon & login
  if (next === 16) {

    if (validate(step)) {
      navigate('next');
      checkoutFlow(next);
    }

    let data = getInput();
    console.log('🐕 Quiz completed - User choices:', data);

    function sanitizeBolean(value) {
      value = value.trim();
      switch (value.toLowerCase()) {
        case 'yes':
          return true;
        case 'no':
          return false;
        default:
          return Boolean(value);
      }
    }


    let subscriptionData = {
      "dog_name": data.name,
      "dog_breed": data.breed,
      "dog_gender": data.gender,
      "dog_neutered": sanitizeBolean(data.neutered),
      "dog_years": data.years,
      "dog_months": data.months,
      "dog_weight": data.weight,
      "dog_weightgroup": data.weightgroup,
      "dog_activity": data.activity,
      "dog_treats": data.treats,
      "dog_allergies": data.allergies,
      "dog_eating": data.food,
      "dog_fussy_dog": data.fussy_dog,
      "dog_prefered_treat": data.prefered_treat,
      "dog_health_issues": data.health_issues,
    }


    // Calculate age in months
    let months;
    months = (parseInt(subscriptionData.dog_years) * 12) + parseInt(subscriptionData.dog_months);

    if (months > 11) {
      isPuppy = false;
    }


    // Get multiplier
    let multiplier;
    if (months < 6) {
      multiplier = 1.8;
    } else if (months < 9) {
      multiplier = 1.6;
    } else if (months < 12) {
      multiplier = 1.4;
    } else {
      multiplier = 1.2;
    }

    // Adjust multiplier by activity
    if (months >= 12) {
      multiplier -= (subscriptionData['dog_activity'] < 2) ? 0.1 : 0; // Inactive
      multiplier += (subscriptionData['dog_activity'] > 2) ? 0.1 : 0; // Very active
    }

    // Adjust multiplier by weight group
    if (months < 12) {
      // Puppy
      multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
    } else {
      // Adult
      multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
      multiplier *= (subscriptionData['dog_weightgroup'] > 2) ? 0.9 : 1; // Overweight
    }

    // Adjust multiplier if neutered
    multiplier *= (subscriptionData['dog_neutered'] && months >= 6) ? 0.9 : 1;

    // Treats to multiplier
    const treats = 1 - ((subscriptionData['dog_treats'] - 1) * 0.05);

    let percentage = 100;

    // Calculate calorie requirement
    const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
    const MER = (RER * multiplier) * treats;
    const MERReduced = MER * (percentage / 100);

    // Daily & monthly dinings/cartons
    const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
    const dailyCartons = dailyDinings / 4; // Convert to quarters
    monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays

    document.getElementById('cal_counter').innerHTML = Math.round(MER);
  }

  if (next === 17) {
    /*navigate('next');
    checkoutFlow(next);
    let dog = document.querySelector('input[name="dog_name"]').value;*/

    /*console.log(orderData["health_issues"]["answer"]);
    console.log(orderData["treats"]["answer"]);
  	
    var introText = 'Since '+dog+' ';
    if(orderData["fussy_dog"]["answer"] == "yes") {
      introText = introText+'is fussy, ';
    }
  	
    const healtIssues = [];
    orderData["health_issues"]["answer"].forEach(function(item) {
        if('sensitive_stomach' == item) {
          healtIssues.push('a sensitive stomach');
        }
        if('bad_breath' == item) {
          healtIssues.push('dental issues or bad breath');
        }
        if('joint_pain' == item) {
          healtIssues.push('joint stiffness or pain');
        }
        if('dry_coat' == item) {
          healtIssues.push('itchy or dull coat');
        }
    });
  	
    if(healtIssues.length > 0) {
      introText = introText+healtIssues.join(', ');
    }
  	
    if(orderData["treats"]["answer"] != 'Never') {
      introText = introText+"and "+orderData['treats']['answer'].toLowerCase()+' get treats';
    }
  	
    introText = introText+', your might consider adding a few extra products to your meal plan.';	
    */
    /*var introText = 'Based on your answers in our nutritional consultation, we think you might be interested in the following products for '+dog+'.';
  	
    console.log(introText);
  	
    jQuery('#extras_intro').html(introText);*/

  }

  // Load checkout
  if (next === 18) {
    checkoutFlow(next);
    navigate('next');
    document.querySelector('nav.bottom__navigation').style.display = 'none';
    backButton.classList.add("disabled");
    nextButton.classList.add("disabled");

    console.log('Preparing checkout\n');

    // handleCheckout();

  }

  document.querySelector('.wizard-v2').dataset.current = step;

}

jQuery("#have_discount").on('click', function (e) {
  jQuery('.discount-input-wrapper').toggleClass('active');
});

function emptyCartOnStart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      console.log('Cart cleared:', data);
      // Optionally, refresh the page or update the cart UI here
    })
    .catch(error => console.error('Error clearing cart:', error));
}



nextButton.addEventListener("click", () => {
  handleSteps();
});
startButton.addEventListener("click", () => {
  handleSteps();
  emptyCartOnStart();
  // $('.apply-coupon').click();
});
checkoutButton?.addEventListener("click", () => {

  handleSteps();
});
skipButton?.addEventListener("click", () => {
  handleSteps();
});

backButton.addEventListener("click", () => {

  navigate('back');

  if (step === 1) { backButton.classList.add("disabled"); }

  if (step === 5) {

    // Reset navigation button
    nextButton.classList.remove("disabled");
    nextButton.textContent = 'Next';

    // Destroy flickity
    if (flkty) {
      flkty.destroy();
      flkty = false;
      console.log('Flickity destroyed');
    }

  }

});











function getBreeds(path) {
  var csv = breedsData;
  return csv.split('\n');
}

var breeds = getBreeds();
const input = document.querySelector(".autocomplete");

function autocomplete(inp, arr) {
  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
  var currentFocus;
  /*execute a function when someone writes in the text field:*/
  inp.addEventListener("input", function (e) {
    var a,
      b,
      i,
      val = this.value;
    /*close any already open lists of autocompleted values*/
    closeAllLists();
    if (!val || val.length < 2) {
      return false;
    }
    currentFocus = -1;
    /*create a DIV element that will contain the items (values):*/
    a = document.createElement("DIV");
    a.setAttribute("id", this.id + "autocomplete-list");
    a.setAttribute("class", "autocomplete-items");
    /*append the DIV element as a child of the autocomplete container:*/
    this.parentNode.appendChild(a);
    /*for each item in the array...*/
    for (i = 0; i < arr.length; i++) {
      /* Lowercase */
      var $breed = arr[i].toLowerCase();
      var $input = val.toLowerCase();
      /*check if the item starts with the same letters as the text field value:*/
      if ($breed.indexOf($input) !== -1) {
        /*create a DIV element for each matching element:*/
        b = document.createElement("DIV");
        /*make the matching letters bold:*/
        b.innerHTML = (arr[i].toLowerCase()).replace($input, "<strong>" + $input + "</strong>");
        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        b.dispatchEvent(evt);
        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener("click", function (e) {
          /*insert the value for the autocomplete text field:*/
          inp.value = this.getElementsByTagName("input")[0].value;
          inp.dispatchEvent(evt);
          /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });
  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener("keydown", function (e) {
    var x = document.getElementById(this.id + "autocomplete-list");
    if (x) x = x.getElementsByTagName("div");
    if (e.keyCode == 40) {
      /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
      currentFocus++;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.keyCode == 38) {
      //up
      /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
      currentFocus--;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.keyCode == 13) {
      /*If the ENTER key is pressed, prevent the form from being submitted,*/
      e.preventDefault();
      if (currentFocus > -1) {
        /*and simulate a click on the "active" item:*/
        if (x) x[currentFocus].click();
      }
    }
  });
  function addActive(x) {
    /*a function to classify an item as "active":*/
    if (!x) return false;
    /*start by removing the "active" class on all items:*/
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = x.length - 1;
    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add("autocomplete-active");
  }
  function removeActive(x) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }
  function closeAllLists(elmnt) {
    /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
    var x = document.getElementsByClassName("autocomplete-items");
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
  /*execute a function when someone clicks in the document:*/
  document.addEventListener("click", function (e) {
    closeAllLists(e.target);
  });
}

autocomplete(input, breeds);


const allCheckboxesAllergies = document.querySelectorAll("input[name='allergies']");

jQuery('input[name="allergies"]').on('click', function () {

  if (this.value == 'Nothing') {

    if (this.checked) {
      allCheckboxesAllergies.forEach(item => {
        if (item.value == 'Nothing') { return; }
        item.checked = false;
      });
    }

  } else {
    document.querySelector('input[name="allergies"][value="Nothing"]').checked = false;
  }

});


const allCheckboxesHealth = document.querySelectorAll("input[name='health_issues']");

jQuery('input[name="health_issues"]').on('click', function () {

  if (this.value == 'No health issues') {

    if (this.checked) {
      allCheckboxesHealth.forEach(item => {
        if (item.value == 'No health issues') { return; }
        item.checked = false;
      });
    }

  } else {
    document.querySelector('input[name="health_issues"][value="No health issues"]').checked = false;
  }

});




const allCheckboxesTreats = document.querySelectorAll("input[name='prefered_treat']");

jQuery('input[name="prefered_treat"]').on('click', function () {

  if (this.value == 'none') {

    if (this.checked) {
      allCheckboxesTreats.forEach(item => {
        if (item.value == 'none') { return; }
        item.checked = false;
      });
    }

  } else {
    document.querySelector('input[name="prefered_treat"][value="none"]').checked = false;
  }

});






function sanitizeBolean(value) {
  value = value.trim();
  switch (value.toLowerCase()) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return Boolean(value);
  }
}


function mealDistribution(split, monthlyCartons) {
  let foodPackage = {
    'chicken': split['chicken'] ? Math.round(monthlyCartons * split['chicken']) : 0,
    'beef': split['beef'] ? Math.round(monthlyCartons * split['beef']) : 0,
    'lamb': split['lamb'] ? Math.round(monthlyCartons * split['lamb']) : 0,
    'salmon': split['salmon'] ? Math.round(monthlyCartons * split['salmon']) : 0
  };

  // Increase package until monthly target is met
  let difference = Math.round(monthlyCartons - Object.values(foodPackage).reduce((a, b) => a + b, 0));
  while (difference > 0) {
    for (let type in foodPackage) {
      if (difference > 0 && split.hasOwnProperty(type)) {
        foodPackage[type] += 1;
        difference -= 1;
      }
    }
  }

  return foodPackage;
}


// Default package split
let split = {
  chicken: 0.35,
  beef: 0.3,
  lamb: 0.2,
  salmon: 0.15,
};

// Default package split
let trialSplit = {
  chicken: 0.25,
  beef: 0.25,
  lamb: 0.25,
  salmon: 0.25,
};

// Function to increase split percentages if the total is less than 1
function adjustSplitPercentage(split) {
  const totalSplit = Object.values(split).reduce((acc, val) => acc + val, 0);

  if (totalSplit < 1) {
    const diff = 1 - totalSplit;
    const count = Object.keys(split).length;

    for (const key in split) {
      split[key] += diff / count;
    }
  }

  return split;
}


// Remove ingredients if allergic
function removeAllergicIngredients(subscriptionData) {
  subscriptionData.dog_allergies.forEach(allergy => {
    delete split[allergy.toLowerCase()];
    delete trialSplit[allergy.toLowerCase()];
  });

  split = adjustSplitPercentage(split);
  trialSplit = adjustSplitPercentage(trialSplit);

  return true;
}


let feedingGuide;

function feedingGuideCalc(mealCount) {
  // Calculate y as x divided by 14
  const packPercentage = mealCount / wpDays;

  // If y is less than 0.25, set it to 0.25
  if (packPercentage < 0.25) {
    return 0.25;
  }

  // Round y to the nearest 0.25
  const roundedpackPercentage = Math.round(packPercentage * 4) / 4;

  return roundedpackPercentage;
}

function decimalToFraction(decimal) {
  if (decimal === Math.floor(decimal)) {
    return decimal.toString(); // It's a whole number
  }

  const wholeNumber = Math.floor(decimal);
  const fractionalPart = decimal - wholeNumber;

  const precision = 100000; // Precision to avoid floating-point issues
  const numerator = Math.round(fractionalPart * precision);
  const denominator = precision;

  // Simplify the fraction using the greatest common divisor (GCD)
  function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
  }

  const divisor = gcd(numerator, denominator);
  const simplifiedNumerator = numerator / divisor;
  const simplifiedDenominator = denominator / divisor;

  if (wholeNumber === 0) {
    return `<sup>${simplifiedNumerator}</sup>/<sub>${simplifiedDenominator}</sub>`;
  }

  return `${wholeNumber}<sup>${simplifiedNumerator}</sup>/<sub>${simplifiedDenominator}</sub>`;
}


function calculateMealPlan(payload) {

  let payloadData = JSON.parse(payload);
  let fullPrice = 0;
  let trialPrice = 0;
  let fullPlanPrice = 0;

  let subscriptionData = {
    "dog_name": payloadData.name,
    "dog_breed": payloadData.breed,
    "dog_gender": payloadData.gender,
    "dog_neutered": sanitizeBolean(payloadData.neutered),
    "dog_years": payloadData.years,
    "dog_months": payloadData.months,
    "dog_weight": payloadData.weight,
    "dog_weightgroup": payloadData.weightgroup,
    "dog_activity": payloadData.activity,
    "dog_treats": payloadData.treats,
    "dog_allergies": payloadData.allergies,
    "dog_eating": payloadData.food,
    "dog_fussy_dog": payloadData.fussy_dog,
    "dog_prefered_treat": payloadData.prefered_treat,
    "dog_health_issues": payloadData.health_issues,
  }

  removeAllergicIngredients(subscriptionData);

  // Calculate age in months
  let months;
  months = (subscriptionData['dog_years'] * 12) + subscriptionData['dog_months'];

  // Get multiplier
  let multiplier;
  if (months < 6) {
    multiplier = 1.8;
  } else if (months < 9) {
    multiplier = 1.6;
  } else if (months < 12) {
    multiplier = 1.4;
  } else {
    multiplier = 1.2;
  }

  // Adjust multiplier by activity
  if (months >= 12) {
    multiplier -= (subscriptionData['dog_activity'] < 2) ? 0.1 : 0; // Inactive
    multiplier += (subscriptionData['dog_activity'] > 2) ? 0.1 : 0; // Very active
  }

  // Adjust multiplier by weight group
  if (months < 12) {
    // Puppy
    multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
  } else {
    // Adult
    multiplier *= (subscriptionData['dog_weightgroup'] < 2) ? 1.1 : 1; // Underweight
    multiplier *= (subscriptionData['dog_weightgroup'] > 2) ? 0.9 : 1; // Overweight
  }

  // Adjust multiplier if neutered
  multiplier *= (subscriptionData['dog_neutered'] && months >= 6) ? 0.9 : 1;

  // Treats to multiplier
  const treats = 1 - ((subscriptionData['dog_treats'] - 1) * 0.05);

  let percentage = 100;

  // Calculate calorie requirement
  const RER = 70 * Math.pow(subscriptionData['dog_weight'], 0.75);
  const MER = (RER * multiplier) * treats;
  const MERReduced = MER * (percentage / 100);

  // Daily & monthly dinings/cartons
  const dailyDinings = Math.round(MERReduced / 125); // Round to nearest integer
  const dailyCartons = dailyDinings / 4; // Convert to quarters
  monthlyCartons = dailyCartons * wpDays; // Multiply by wpDays

  // document.getElementById('cartons-per-day').innerHTML = decimalToFraction(dailyCartons);

  // if (Number(dailyCartons) >= 2) {
  //   document.getElementById('cartons-plaural').innerHTML = "s";
  // }

  let foodPackage = mealDistribution(split, monthlyCartons);
  let trialFoodPackage = mealDistribution(trialSplit, trialCartons);

  /* dog treats */
  let preferedTreat = {};
  if (subscriptionData['dog_treats'] > 1) {
    let treatList = [
      "lamb",
      "chicken",
      "beef"
    ];

    if (subscriptionData['dog_prefered_treat'] == 'none') {
      subscriptionData.dog_allergies.forEach(allergy => {
        // Find the index of the allergy in the treatList
        const index = treatList.indexOf(allergy.toLowerCase());
        // If the allergy is in treatList, remove it
        if (index !== -1) {
          treatList.splice(index, 1); // Remove the item at the found index
        }
      });

      if (treatList.length) {
        //select first from list (predefined order)
        let objKey = treatList[0];
        preferedTreat[objKey] = 1
      } else {
        preferedTreat = "no treats";
      }
    } else {
      // 1 product per chosen flavour
      if (Array.isArray(subscriptionData['dog_prefered_treat'])) {
        subscriptionData['dog_prefered_treat'].forEach((item) => {
          preferedTreat[item] = 1;
        });
      } else if (subscriptionData['dog_prefered_treat']) {
        preferedTreat[subscriptionData['dog_prefered_treat']] = 1;
      }
    }

  }


  /* dog supplements */
  let supplements = {};
  let supplementsQuantity = 1;

  // function calculateAdditions(weight) {
  //     if (weight < 10) {
  //         return 1;
  //     } else if (weight <= 25) {
  //         return 2;
  //     } else if (weight <= 40) {
  //         return 3;
  //     } else {
  //         // Calculate additional additions for weights above 40kg
  //         const extraWeight = weight - 40;
  //         const extraAdditions = Math.ceil(extraWeight / 15);
  //         return 3 + extraAdditions;
  //     }
  // }

  if (months >= 6) {

    if (subscriptionData['dog_health_issues'].includes('dry, itchy or dull coat')) {
      supplements.oil = supplementsQuantity; // Add "oil" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('a sensitive stomach')) {
      supplements.gut = supplementsQuantity; // Add "gut" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('dental issues or bad breath')) {
      supplements.dental = supplementsQuantity; // Add "dental" supplement
    }

    if (subscriptionData['dog_health_issues'].includes('joint stiffness or pain')) {
      supplements.joint = supplementsQuantity; // Add "joint" supplement
    }

    // Recommend joint supplement for dogs 7+ years old
    if (months >= 84 && !supplements.joint) {
      supplements.joint = supplementsQuantity;
    }

  }

  let totalPackage = {
    foodPackage,
    preferedTreat,
    supplements
  };

  let trialPackage = {
    foodPackage: trialFoodPackage,
    preferedTreat,
    supplements
  };

  //get quantites from api
  let response = totalPackage;
  const cartQuantites = {};
  const trialCartQuantities = {};


  /* MEALS */
  //match quantites with products
  for (const product of productList) {
    for (const [key, value] of Object.entries(response.foodPackage)) {
      if (product.title.toLowerCase().includes(key)) {
        cartQuantites[product.variants[0].id] = value;
        fullPrice += product.price * value;
        break;
      }
    }

    for (const [key, value] of Object.entries(trialPackage.foodPackage)) {
      if (product.title.toLowerCase().includes(key)) {
        trialCartQuantities[product.variants[0].id] = value;
        trialPrice += product.price * value;
        break;
      }
    }

  }
  fullPlanPrice += fullPrice;


  const mealTotalCount = Object.values(response.foodPackage).reduce((sum, value) => sum + value, 0);
  feedingGuide = feedingGuideCalc(mealTotalCount);

  const mealFoodIncluded = Object.keys(response.foodPackage)
    .filter(key => response.foodPackage[key] !== 0)
    .join(', ');

  // Calculate half plan meals (round up if odd)
  const halfPlanMeals = Math.ceil(mealTotalCount / 2);

  // Get the allowed proteins from foodPackage
  const allowedProteins = Object.keys(response.foodPackage).filter(key => response.foodPackage[key] > 0);

  // Calculate half plan distribution using filterSplitAdjust
  const halfPlanSplit = filterSplitAdjust(allowedProteins, false);
  const halfPlanDistribution = mealDistribution(halfPlanSplit, halfPlanMeals);

  // Build half plan cart quantities by variant ID (same method as cartQuantites)
  const halfPlanCartQuantities = {};
  let halfPlanMealPrice = 0;
  for (const product of productList) {
    for (const [key, value] of Object.entries(halfPlanDistribution)) {
      if (product.title.toLowerCase().includes(key)) {
        halfPlanCartQuantities[product.variants[0].id] = value;
        halfPlanMealPrice += product.price * value;
        break;
      }
    }
  }

  if (trial) {
    $('.meal-portions').html(halfPlanMeals);
    $('[data-trial-meal-portions]').html(trialCartons + 'x');
  } else {
    $('.meal-portions').html(halfPlanMeals);
  }
  $('.meal-portions-full').html(mealTotalCount);
  $('.meal-contains').html(mealFoodIncluded);



  /* TREATS */
  let prefferedTreats = preferedTreat;
  let treatsTotalPrice = 0;

  if (Object.keys(prefferedTreats).length > 0) {

    const mealFoodIncluded = Object.keys(prefferedTreats)
      .filter(key => response.preferedTreat[key] !== 0)
      .join(', ');

    for (const treat of treatsList) {
      for (const [key, value] of Object.entries(prefferedTreats)) {
        if (treat.title.toLowerCase().includes(key)) {
          cartQuantites[treat.variants[0].id] = value;
          fullPrice += treat.price * value;
          fullPlanPrice += treat.price * value;
          treatsTotalPrice += treat.price * value;

          trialCartQuantities[treat.variants[0].id] = value;
          trialPrice += treat.price * value;

          // Half plan gets same treats as full plan
          halfPlanCartQuantities[treat.variants[0].id] = value;
        }
      }

      $('.treat-contains').html(mealFoodIncluded);
      $('.treat-count').html(Object.keys(prefferedTreats).length);
      $('[data-trial-treat-count]').html(Object.keys(prefferedTreats).length + 'x');
      $('[data-trial-treat-contains]').html(mealFoodIncluded);

    }
  } else {
    $('[data-plan-type="treats"]').hide();
  }

  /* SUPPLEMENTS */
  let supplementsCalc = response.supplements;
  let supplementsTotalPrice = 0;
  if (Object.keys(supplementsCalc).length && months >= 6) {
    for (const supplement of supplementList) {
      for (const [key, value] of Object.entries(supplementsCalc)) {
        if (supplement.title.toLowerCase().includes(key)) {
          cartQuantites[supplement.variants[0].id] = value;
          fullPrice += supplement.price * value;
          fullPlanPrice += supplement.price * value;
          supplementsTotalPrice += supplement.price * value;

          trialCartQuantities[supplement.variants[0].id] = value;
          trialPrice += supplement.price * value;

          // Half plan gets same supplements as full plan
          halfPlanCartQuantities[supplement.variants[0].id] = value;

          break;
        }
      }
    }

    const newItems = Object.entries(supplementsCalc)
      .filter(([, value]) => value !== 0)
      .map(([name, qty]) => `
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <rect y="0.629883" width="23.76" height="23.76" rx="11.88" fill="#E6FFD4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.88 24.3899C18.4413 24.3899 23.76 19.0712 23.76 12.5099C23.76 5.94856 18.4413 0.629883 11.88 0.629883C5.31868 0.629883 0 5.94856 0 12.5099C0 19.0712 5.31868 24.3899 11.88 24.3899ZM16.0808 8.30911C16.3038 8.08635 16.6063 7.96134 16.9215 7.96156C17.2368 7.96178 17.539 8.08723 17.7618 8.3103C17.9845 8.53338 18.1096 8.83581 18.1093 9.15106C18.1091 9.46631 17.9837 9.76856 17.7606 9.99132L11.0448 16.7071L11.0401 16.7118C10.93 16.8225 10.7991 16.9104 10.655 16.9703C10.5109 17.0303 10.3563 17.0612 10.2002 17.0612C10.0441 17.0612 9.88948 17.0303 9.74534 16.9703C9.60119 16.9104 9.47032 16.8225 9.36025 16.7118L9.3555 16.7071L5.9994 13.351C5.88593 13.2414 5.79543 13.1103 5.73317 12.9654C5.67091 12.8204 5.63813 12.6645 5.63676 12.5068C5.63539 12.3491 5.66545 12.1926 5.72518 12.0466C5.78492 11.9006 5.87313 11.768 5.98467 11.6564C6.09622 11.5449 6.22886 11.4567 6.37486 11.3969C6.52086 11.3372 6.6773 11.3071 6.83504 11.3085C6.99278 11.3099 7.14867 11.3427 7.29361 11.4049C7.43855 11.4672 7.56964 11.5577 7.67923 11.6712L10.2002 14.1909L16.0808 8.3103V8.30911Z" fill="#00592F"/>
          </svg>
          <div>${qty}x ${name} supplement</div>
        </li>
      `).join('');
    $('[data-plan-type="supplements"]')?.replaceWith(newItems);
  } else {
    $('[data-plan-type="supplements"]').hide();
  }

  cartObject = cartQuantites;
  cartTrialObject = trialCartQuantities;
  cartHalfObject = halfPlanCartQuantities;

  let totalPrice = fullPrice;
  let fullPriceOutput = ((fullPrice / 100) / wpDays).toFixed(2);
  let discountedPriceOutput = (((fullPrice / 100) / wpDays) * (1 - discountCodeValue)).toFixed(2);
  let trialDiscountedPriceOutput = ((trialPrice / 100) * (1 - discountCodeValue)).toFixed(2);

  totalPrice = Shopify.formatMoney(
    totalPrice * (1 - discountCodeValue),
    Shopify.money_format
  );

  fullPriceOutput = Shopify.formatMoney(
    fullPriceOutput * 100,
    Shopify.money_format
  );

  discountedPriceOutput = Shopify.formatMoney(
    discountedPriceOutput * 100,
    Shopify.money_format
  );

  let trialFullPriceOutput = Shopify.formatMoney(
    trialPrice,
    Shopify.money_format
  );

  trialDiscountedPriceOutput = Shopify.formatMoney(
    trialDiscountedPriceOutput * 100,
    Shopify.money_format
  );

  let volumeDiscount = 0.1; // $0-74: 10%

  //volume discounts
  if (parseInt(fullPlanPrice) >= 12000) {
    volumeDiscount = 0.25; // $120+: 25%
  } else if (parseInt(fullPlanPrice) >= 10000) {
    volumeDiscount = 0.2; // $100-119: 20%
  } else if (parseInt(fullPlanPrice) >= 7500) {
    volumeDiscount = 0.15; // $75-99: 15%
  }

  // let fullPlanPriceOutput = ((fullPlanPrice / 100) / wpDays).toFixed(2);
  // let discountedPlanPriceOutput = (((fullPlanPrice / 100) / wpDays) * (1 - volumeDiscount)).toFixed(2);

  let fullPlanPriceOutput = fullPlanPrice / 100;
  let discountedPlanPriceOutput = ((fullPlanPrice / 100) * (1 - volumeDiscount)).toFixed(2);

  fullPlanPriceOutput = Shopify.formatMoney(
    fullPlanPriceOutput * 100,
    Shopify.money_format
  );

  discountedPlanPriceOutput = Shopify.formatMoney(
    discountedPlanPriceOutput * 100,
    Shopify.money_format
  );

  //trial plan info display
  if (trial) {
    // $('.plan-box--half .post-wizard-recommendation__info-discount').hide();
    $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(trialFullPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(trialDiscountedPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
    $('[data-trial-box-compare-price]').html(trialFullPriceOutput);
    $('[data-trial-box-price]').html(trialDiscountedPriceOutput);
  } else {
    $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(fullPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(discountedPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
    $('[data-trial-box-compare-price]').html(fullPriceOutput);
    $('[data-trial-box-price]').html(discountedPriceOutput);
  }
  $('[data-quiz-trial-discount]').html(discountCodeValue * 100);

  //full plan info display
  $('.pw-full.post-wizard-recommendation__info-discount--full-price').html(fullPlanPriceOutput);
  $('.pw-full.post-wizard-recommendation__info-discount--discounted-price').html(discountedPlanPriceOutput);
  $('.pw-full.post-wizard-recommendation__info-discount--discounted-percentage').html(volumeDiscount * 100);
  $('[data-quiz-plan-discount="full"], [data-quiz-plan-discount="selected"]').html(volumeDiscount * 100);

  const fullPlanPricePerDay = Shopify.formatMoney(fullPlanPrice / 28, Shopify.money_format);
  const discountedPlanPricePerDay = Shopify.formatMoney((fullPlanPrice * (1 - volumeDiscount)) / 28, Shopify.money_format);

  $('[data-full-box-compare-price]').html(fullPlanPricePerDay);
  $('[data-full-box-price]').html(discountedPlanPricePerDay + '/day');

  $('[data-selected-box-compare-price]').html(fullPlanPricePerDay);
  $('[data-selected-box-price]').html(discountedPlanPricePerDay + '/day');

  // Half plan price calculation (half meals + same treats + same supplements)
  const halfPlanPrice = halfPlanMealPrice + treatsTotalPrice + supplementsTotalPrice;

  // Apply volume discount based on half plan price
  let halfVolumeDiscount = 0.1; // $0-74: 10%
  if (parseInt(halfPlanPrice) >= 12000) {
    halfVolumeDiscount = 0.25; // $120+: 25%
  } else if (parseInt(halfPlanPrice) >= 10000) {
    halfVolumeDiscount = 0.2; // $100-119: 20%
  } else if (parseInt(halfPlanPrice) >= 7500) {
    halfVolumeDiscount = 0.15; // $75-99: 15%
  }

  const halfPlanComparePrice = Shopify.formatMoney(halfPlanPrice, Shopify.money_format);
  const halfPlanDiscountedPrice = Shopify.formatMoney(
    halfPlanPrice * (1 - halfVolumeDiscount),
    Shopify.money_format
  );

  const halfPlanComparePricePerDay = Shopify.formatMoney(halfPlanPrice / 28, Shopify.money_format);
  const halfPlanDiscountedPricePerDay = Shopify.formatMoney((halfPlanPrice * (1 - halfVolumeDiscount)) / 28, Shopify.money_format);

  $('[data-half-box-compare-price]').html(halfPlanComparePricePerDay);
  $('[data-half-box-price]').html(halfPlanDiscountedPricePerDay + '/day');
  $('[data-quiz-plan-discount="half"]').html(halfVolumeDiscount * 100);

  // Calculate trial box savings (compare price - discounted price)
  const trialBoxSavings = Shopify.formatMoney(
    trialPrice - (trialPrice * (1 - discountCodeValue)),
    Shopify.money_format
  );
  $('[data-trial-box-savings]').html(`-${trialBoxSavings}`);

  $('[data-trial-end-date]').html(getTrialEndDate());

  // $('.post-wizard-sticky-cta #total_price').html(totalPrice);

  // Get all elements with the class 'wizard-product-card'
  const productCards = document.querySelectorAll('.wizard-product-card');

  // Iterate over the elements and check if 'data-variant-id' is in the object
  productCards.forEach(card => {
    const variantId = card.getAttribute('data-variant-id');

    if ((cartObject.hasOwnProperty(variantId) && cartObject[variantId] !== 0) || (cartTrialObject.hasOwnProperty(variantId) && cartTrialObject[variantId] !== 0)) {
      card.classList.add('is-selected');

      // Half plan box - use halfPlanCartQuantities for meals
      const halfPlanBox = card.closest('.plan-box--half .plan-box__summary-cards');
      if (halfPlanBox) {
        const mealsDetail = card.closest('[data-plan-type="meals"]');
        if (mealsDetail && halfPlanCartQuantities[variantId]) {
          card.querySelector('span').innerHTML = halfPlanCartQuantities[variantId];
        } else {
          // For treats and supplements, use the same quantities as full plan
          card.querySelector('span').innerHTML = cartObject[variantId];
        }
      }

      // Full plan box - use full meal quantities
      const fullPlanBox = card.closest('.plan-box--full .plan-box__summary-cards');
      if (fullPlanBox) {
        card.querySelector('span').innerHTML = cartObject[variantId];
      }
    }

    if (card.querySelector('.wizard-product-card__price-wrapper')) {
      let temp_price = card.dataset.price;
      card.querySelector('.wizard-product-card__price-wrapper .wizard-product-card__discounted-price').innerHTML = Shopify.formatMoney(
        temp_price * (1 - discountCodeValue),
        Shopify.money_format
      );
    }
  });

}

function validateEmail() {
  const emailInput = document.querySelector('input[name="owner_email"]');
  const emailValue = emailInput.value.trim();

  // Email validation regex pattern
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (emailValue === "" || !emailPattern.test(emailValue)) {
    return false; // Invalid email
  }

  return true; // Valid email
}

document.querySelector('.final-step-flow input[name="owner_email"]').addEventListener('focus', function () {
  document.querySelector('.invalid-email').classList.remove('triggered');
});

$('.trigger-post-quiz').click(function () {
  if ($(this).hasClass('next__button') && validateEmail()) {

    //add mail to klaviyo
    if (document.querySelector('.final-step-flow input[name="mc_signup"]').checked) {

      const userEmail = document.querySelector('.final-step-flow [name="owner_email"]').value;
      const originalDogProfile = getInput();

      if (!originalDogProfile) {
        console.error('getInput() returned nothing or invalid data');
        return;
      }

      // Define the value mappings
      const activityLevelMap = { 1: 'Pretty snoozy', 2: 'Active', 3: 'Explosion of energy' };
      const bodyTypeMap = { 1: 'A bit skinny', 2: 'Just paw-fect', 3: 'A bit chonky' };
      const treatsPerDayMap = { 1: 'Never', 2: 'Sometimes', 3: 'Pretty often' };
      const fussyLevelMap = {
        'Yes': 'Very fussy',
        'Between': 'A little fussy',
        'No': 'Not fussy'
      };

      console.log('originalDogProfile', originalDogProfile)

      // Create the new object with the correct Klaviyo property names and mapped values
      const klaviyoProfile = {
        dog_name: originalDogProfile.name,
        dog_gender: originalDogProfile.gender,
        dog_spayed_neutered: originalDogProfile.neutered,
        dog_breed: originalDogProfile.breed,
        dog_life_stage: (() => {
          const totalMonths = (originalDogProfile.years * 12) + originalDogProfile.months;
          if (totalMonths < 12) return 'Puppy';
          if (totalMonths > 84) return 'Senior';
          return 'Adult';
        })(),
        dog_weight_kg: originalDogProfile.weight,

        // Use the maps to get the string values
        dog_bodytype: bodyTypeMap[originalDogProfile.weightgroup],
        dog_activity_level: activityLevelMap[originalDogProfile.activity],
        dog_treats_per_day: treatsPerDayMap[originalDogProfile.treats],
        dog_fussy_level: fussyLevelMap[originalDogProfile.fussy_dog],

        dog_allergies_dislikes: originalDogProfile.allergies,
        dog_current_diet: originalDogProfile.food,
        dog_health_issues: originalDogProfile.health_issues,
        dog_treat_preference: originalDogProfile.prefered_treat,
      };

      // console.log('klaviyoProfile', klaviyoProfile)

      // Subscribe Profile to List (Creates profile if needed)
      const subscribeOptions = {
        method: 'POST',
        headers: { revision: '2023-06-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: 'XWKRtA',
              custom_source: 'Wizard',
              email: userEmail,
              properties: {
                hasPuppy: isPuppy,
                ...klaviyoProfile
              }
            }
          }
        })
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R6vSRF', subscribeOptions)
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          console.log('Step 1: Profile subscribed successfully.', subscribeOptions);
          return;
        })
        .then(() => {
          // Send the 'Completed Dog Quiz' Event
          const eventOptions = {
            method: 'POST',
            headers: { revision: '2023-06-15', 'content-type': 'application/json' },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: klaviyoProfile,
                  metric: { name: 'Completed Dog Quiz' },
                  profile: { email: userEmail }
                }
              }
            })
          };
          return fetch('https://a.klaviyo.com/client/events/?company_id=R6vSRF', eventOptions);
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          console.log('Step 2: "Completed Dog Quiz" event sent successfully!');
        })
        .catch(err => console.error('Klaviyo API Error:', err));
    }

    let genderContainer = $('.dog-gender');
    let genderPossessive = $('.dog-gender-possessive');
    let gender = document.querySelector('input[name="gender"]:checked').value;
    genderContainer.html(gender === 'Boy' ? 'he' : 'she');
    genderPossessive.html(gender === 'Boy' ? 'his' : 'her');

    saveQuizProgress(16);
    handleLoader();
    calculateMealPlan(JSON.stringify(getInput()));

    $('.wizard-v2').hide();
    $('.post-wizard-wrapper').show();
    scrollToTop();

    //for tracking purposes
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "checkout",
      ecommerce: {
        checkout: {
          actionField: {
            step: 17
          }
        }
      }
    });


    $('.wizard-page-post-extra').show();
    $('.wizard-section-post-extra').show();
    // Select the accordion tab component
    const accordionTabs = document.querySelectorAll('accordion-tab');

    accordionTabs.forEach(accordion => {
      // Clone the component to avoid retaining event listeners
      const newAccordion = accordion.cloneNode(true);
      const parent = accordion.parentElement;

      // Remove the original from the DOM
      parent.removeChild(accordion);

      // Append the cloned (new) component to reinitialize it
      parent.appendChild(newAccordion);
    });

  } else {
    document.querySelector('.invalid-email').classList.add('triggered');
  }

});

$('.edit-plan-trigger').click(function () {
  $('.post-wizard-recommendation, .wizard-page-post-extra, .post-wizard-plan-overview').hide();
  $('.post-wizard-editor, .post-wizard-sticky-cta').show();
  recalculateMeals();
  scrollToTop();
});

$('[data-box-plan-label]').on('click', function (e) {
  e.preventDefault();
  const selectedPlan = e.currentTarget.dataset.boxPlanLabel;
  $('[data-selected-plan]').html(selectedPlan);

  document.querySelector(`input[name="box-plan"][value="${selectedPlan}"]`).checked = true;

  if (selectedPlan === 'full plan') {
    $('[data-selected-box-price]').html($('[data-full-box-price]').html());
    $('[data-selected-box-compare-price]').html($('[data-full-box-compare-price]').html());
    $('[data-quiz-plan-discount="selected"]').html($('[data-quiz-plan-discount="full"]').html());
  } else {
    $('[data-selected-box-price]').html($('[data-half-box-price]').html());
    $('[data-selected-box-compare-price]').html($('[data-half-box-compare-price]').html());
    $('[data-quiz-plan-discount="selected"]').html($('[data-quiz-plan-discount="half"]').html());
  }
});

$('.apply-coupon').click(function () {
  handleCoupon();
});

// Function to add items to Shopify cart
async function addItemsToCart(items, fullPlanCart, halfPlanCart, selectedPlan) {
  const addToCartURL = '/cart/add.js';
  const updateCartURL = '/cart/update.js';

  try {

    // Prepare data as an array of items
    const data = {
      'items': items.map(item => ({
        'id': parseInt(item.id), // Shopify variant ID
        'quantity': item.quantity,
        'selling_plan': "8019935518", // Include selling plan if provided
        'properties': { // Add custom properties
          '_dog_name': dogName,
          '_dynamicBoxIndex': 0,
          '_dynamicBoxId': "b47674e0-72a2-4bff-9c7b-4f2cc0ef47d9"
          // '_dynamicBoxId': "5762e0ee-543e-4588-98ef-c779890d37b3"
        }
      }))
    };

    // Make POST request to add item to the cart
    await fetch(addToCartURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => response.json());
    // }

    // Determine which plan cart to store based on selection
    const selectedPlanCart = selectedPlan === 'half plan' ? halfPlanCart : fullPlanCart;

    // Step 2: Add hidden note as cart attribute
    await fetch(updateCartURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          _hidden_note: JSON.stringify(getInput()), // Custom attribute for hidden note
          _feeding_guide: feedingGuide,
          _dog_name: dogName,
          _selected_plan: trial ? selectedPlan : null,
          _full_month_plan: trial ? JSON.stringify(selectedPlanCart) : null
        }
      }),
    }).then((response) => response.json());

    // Redirect to checkout page
    if (discountCode.length) {
      window.location.href = `/checkout?discount=${discountCode}`;
    } else {
      window.location.href = `/checkout`;
    }
  } catch (error) {
    console.error('Error adding items to cart:', error);
  }
}

//add selected items and proceed to checkout
$('.go-to-checkout').click(function () {
  $('[data-checkout-quiz]').click();
});

// //sync weight inputs
// const weightTextInput = document.getElementById('weightTextInput');
// const weightRangeInput = document.getElementById('weightRangeInput');

// // Update text input when range slider changes
// weightRangeInput.addEventListener('input', (event) => {
//   weightTextInput.value = event.target.value;
// });

// // Update range slider when text input changes
// weightTextInput.addEventListener('input', (event) => {
//   // Ensure the text input value is within range slider's min and max
//   let value = parseFloat(event.target.value);
//   if (value < weightRangeInput.min) value = weightRangeInput.min;
//   if (value > weightRangeInput.max) value = weightRangeInput.max;

//   weightRangeInput.value = value;
// });


// function updateRangeBackground() {
//   const value = (weightRangeInput.value - weightRangeInput.min) / (weightRangeInput.max - weightRangeInput.min) * 100;
//   weightRangeInput.style.background = `linear-gradient(to right, #BFE7AD 0%, #BFE7AD ${value}%, #f3f3f3 ${value}%, #f3f3f3 100%)`;
// }

// weightRangeInput.addEventListener('input', updateRangeBackground);
// weightTextInput.addEventListener('input', updateRangeBackground);
// updateRangeBackground(); // Initialize on load
syncWeightInputs('weightTextInput', 'weightRangeInput');

function filterSplitAdjust(allowedItems, isTrial) {
  let initialSplit;
  if (!isTrial) {
    initialSplit = {
      chicken: 0.35,
      beef: 0.3,
      lamb: 0.2,
      salmon: 0.15
    };
  } else {
    initialSplit = {
      chicken: 0.25,
      beef: 0.25,
      lamb: 0.25,
      salmon: 0.25
    };
  }

  // Iterate over initialSplit keys and delete any that are not in allowedItems
  for (const key in initialSplit) {
    if (!allowedItems.includes(key)) {
      delete initialSplit[key];
    }
  }

  return adjustSplitPercentage(initialSplit);
}


let editCartQuantites = {};
let editTrialCartQuantites = {};
let editHalfCartQuantites = {};

function calcCartQ(data, trialData) {
  for (const product of productList) {
    for (const [key, value] of Object.entries(data)) {
      if (product.title.toLowerCase().includes(key)) {
        if (trialData) {
          editTrialCartQuantites[product.variants[0].id] = value;
        } else {
          editCartQuantites[product.variants[0].id] = value;
        }
        break;
      }
    }
  }
}

function calcHalfCartQ(halfPlanDist) {
  editHalfCartQuantites = {};
  for (const product of productList) {
    for (const [key, value] of Object.entries(halfPlanDist)) {
      if (product.title.toLowerCase().includes(key)) {
        editHalfCartQuantites[product.variants[0].id] = value;
        break;
      }
    }
  }
}

let newSum = 0;
function recalculateTotal() {
  newSum = 0
  // Full plan meal count from meal-portions-full
  let fullMealCount = parseInt($('.meal-portions-full').html()) || 0;
  let halfMealCount = parseInt($('.plan-box--half .meal-portions').html()) || 0;
  let mealPrice = parseInt($('.product-grid.main-meals .wizard-product-card').data('price')) || 0;

  let fullMealsTotal = fullMealCount * mealPrice;
  let halfMealsTotal = halfMealCount * mealPrice;
  let trialMealsTotal = trialCartons * mealPrice; // Trial box is always 4 meals

  let treatsTotal = $('.product-grid.treat-meals .is-selected').length * parseInt($('.product-grid.treat-meals .wizard-product-card').data('price'));
  let supplementsTotal = $('.product-grid.supplement-meals .wizard-product-card.is-selected')
    .toArray() // Convert jQuery object to array
    .reduce((total, el) => total + parseInt($(el).data('price') || 0), 0);

  newSum = fullMealsTotal + treatsTotal + supplementsTotal;

  // Half plan price calculation
  let halfPlanTotal = halfMealsTotal + treatsTotal + supplementsTotal;

  // Trial box price calculation (4 meals + treats + supplements)
  let trialBoxTotal = trialMealsTotal + treatsTotal + supplementsTotal;

  let fullPrice = newSum;
  let fullPriceOutput = fullPrice / 100;
  let discountedPriceOutput = ((fullPrice / 100) * (1 - discountCodeValue)).toFixed(2);

  fullPrice = Shopify.formatMoney(
    fullPrice * (1 - discountCodeValue),
    Shopify.money_format
  );

  fullPriceOutput = Shopify.formatMoney(
    fullPriceOutput * 100,
    Shopify.money_format
  );

  discountedPriceOutput = Shopify.formatMoney(
    discountedPriceOutput * 100,
    Shopify.money_format
  );

  // Trial box formatting
  let trialFullPriceOutput = Shopify.formatMoney(trialBoxTotal, Shopify.money_format);
  let trialDiscountedPriceOutput = Shopify.formatMoney(
    trialBoxTotal * (1 - discountCodeValue),
    Shopify.money_format
  );

  if (trial) {
    $('.pw-trial.post-wizard-recommendation__info-discount--full-price').html(trialFullPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-price').html(trialDiscountedPriceOutput);
    $('.pw-trial.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
  } else {
    $('.post-wizard-recommendation__info-discount--full-price').html(fullPriceOutput);
    $('.post-wizard-recommendation__info-discount--discounted-price').html(discountedPriceOutput);
    $('.post-wizard-recommendation__info-discount--discounted-percentage').html(discountCodeValue * 100);
  }

  $('[data-trial-box-compare-price]').html(trialFullPriceOutput);
  $('[data-trial-box-price]').html(trialDiscountedPriceOutput);

  // Calculate trial box savings
  const trialBoxSavings = Shopify.formatMoney(
    trialBoxTotal * discountCodeValue,
    Shopify.money_format
  );
  $('[data-trial-box-savings]').html(`-${trialBoxSavings}`);

  // Half plan volume discount
  let halfVolumeDiscount = 0.1; // $0-74: 10%
  if (parseInt(halfPlanTotal) >= 12000) {
    halfVolumeDiscount = 0.25; // $120+: 25%
  } else if (parseInt(halfPlanTotal) >= 10000) {
    halfVolumeDiscount = 0.2; // $100-119: 20%
  } else if (parseInt(halfPlanTotal) >= 7500) {
    halfVolumeDiscount = 0.15; // $75-99: 15%
  }

  const halfPlanComparePrice = Shopify.formatMoney(halfPlanTotal, Shopify.money_format);
  const halfPlanDiscountedPrice = Shopify.formatMoney(
    halfPlanTotal * (1 - halfVolumeDiscount),
    Shopify.money_format
  );

  $('[data-half-box-compare-price]').html(Shopify.formatMoney(halfPlanTotal / 28, Shopify.money_format));
  $('[data-half-box-price]').html(Shopify.formatMoney((halfPlanTotal * (1 - halfVolumeDiscount)) / 28, Shopify.money_format) + '/day');

  // Full plan volume discount and display
  let fullVolumeDiscount = 0.1; // $0-74: 10%
  if (parseInt(newSum) >= 12000) {
    fullVolumeDiscount = 0.25; // $120+: 25%
  } else if (parseInt(newSum) >= 10000) {
    fullVolumeDiscount = 0.2; // $100-119: 20%
  } else if (parseInt(newSum) >= 7500) {
    fullVolumeDiscount = 0.15; // $75-99: 15%
  }

  const fullPlanComparePrice = Shopify.formatMoney(newSum, Shopify.money_format);
  const fullPlanDiscountedPrice = Shopify.formatMoney(
    newSum * (1 - fullVolumeDiscount),
    Shopify.money_format
  );

  const fullPlanComparePricePerDay = Shopify.formatMoney(newSum / 28, Shopify.money_format);
  const fullPlanDiscountedPricePerDay = Shopify.formatMoney((newSum * (1 - fullVolumeDiscount)) / 28, Shopify.money_format);
  const halfPlanComparePricePerDay2 = Shopify.formatMoney(halfPlanTotal / 28, Shopify.money_format);
  const halfPlanDiscountedPricePerDay2 = Shopify.formatMoney((halfPlanTotal * (1 - halfVolumeDiscount)) / 28, Shopify.money_format);

  $('[data-full-box-compare-price]').html(fullPlanComparePricePerDay);
  $('[data-full-box-price]').html(fullPlanDiscountedPricePerDay + '/day');

  // Update selected plan prices based on current selection
  const selectedPlan = $('input[name="box-plan"]:checked').val();
  if (selectedPlan === 'full plan') {
    $('[data-selected-box-price]').html(fullPlanDiscountedPricePerDay + '/day');
    $('[data-selected-box-compare-price]').html(fullPlanComparePricePerDay);
  } else {
    $('[data-selected-box-price]').html(halfPlanDiscountedPricePerDay2 + '/day');
    $('[data-selected-box-compare-price]').html(halfPlanComparePricePerDay2);
  }
}


function updateHalfPlanDisplay(halfPlanDist) {
  // Update meal portions total for half plan
  const totalHalfMeals = Object.values(halfPlanDist).reduce((sum, val) => sum + val, 0);
  $('.plan-box--half .meal-portions').html(totalHalfMeals);

  // Update individual meal cards in half plan
  const halfPlanMealCards = document.querySelectorAll('.plan-box--half [data-plan-type="meals"] .wizard-product-card');
  halfPlanMealCards.forEach(card => {
    const foodType = card.dataset.foodType;
    const quantity = halfPlanDist[foodType] || 0;

    if (quantity > 0) {
      card.classList.add('is-selected');
      card.querySelector('span').innerHTML = quantity;
    } else {
      card.classList.remove('is-selected');
    }
  });
}

function recalculateMeals() {
  let currentPicks = $('.main-meals .is-selected');

  let currentSplit = [];
  let currentTrialSplit = [];
  //initial
  currentPicks.each(function () {
    currentSplit.push(this.dataset.foodType);
    currentTrialSplit.push(this.dataset.foodType);


    if ($(this).closest('.product-grid').hasClass('main-meals')) {
      currentSplit.push(this.dataset.foodType);
      currentTrialSplit.push(this.dataset.foodType);
      calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
      calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);

      // Update half plan display
      const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
      const fullMealCount = Object.values(fullMealDist).reduce((sum, val) => sum + val, 0);
      const halfMealCount = Math.ceil(fullMealCount / 2);
      const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
      updateHalfPlanDisplay(halfPlanDist);
      calcHalfCartQ(halfPlanDist);
    }
  });
  recalculateTotal();

  //add items
  $('.wizard-product-card__info-button--add').click(function () {
    let productCard = $(this).closest('.wizard-product-card');
    productCard[0].classList.add('is-selected');
    if ($(this).closest('.product-grid').hasClass('main-meals')) {
      currentSplit.push(productCard[0].dataset.foodType);
      currentTrialSplit.push(productCard[0].dataset.foodType);
      calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
      calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);

      // Update half plan display
      const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
      const fullMealCount = Object.values(fullMealDist).reduce((sum, val) => sum + val, 0);
      const halfMealCount = Math.ceil(fullMealCount / 2);
      const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
      updateHalfPlanDisplay(halfPlanDist);
      calcHalfCartQ(halfPlanDist);
    }
    recalculateTotal();
  });


  //remove items
  $('.wizard-product-card__info-button--remove').click(function () {

    if ($(this).closest('.product-grid').hasClass('main-meals')) {
      if ($('.main-meals .is-selected').length >= 2) {
        let productCard = $(this).closest('.wizard-product-card');
        var index = currentSplit.indexOf(productCard[0].dataset.foodType);
        if (index !== -1) {
          currentSplit.splice(index, 1);
          currentTrialSplit.splice(index, 1);
        }
        productCard[0].classList.remove('is-selected');
        calcCartQ(mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons), false);
        calcCartQ(mealDistribution(filterSplitAdjust(currentTrialSplit, true), trialCartons), true);

        // Update half plan display
        const fullMealDist = mealDistribution(filterSplitAdjust(currentSplit, false), monthlyCartons);
        const fullMealCount = Object.values(fullMealDist).reduce((sum, val) => sum + val, 0);
        const halfMealCount = Math.ceil(fullMealCount / 2);
        const halfPlanDist = mealDistribution(filterSplitAdjust(currentSplit, false), halfMealCount);
        updateHalfPlanDisplay(halfPlanDist);
        calcHalfCartQ(halfPlanDist);
      }
    } else {
      let productCard = $(this).closest('.wizard-product-card');
      productCard[0].classList.remove('is-selected');
    }

    recalculateTotal();
  });

}


$('[data-checkout-quiz]').click(function () {
  //get meals
  recalculateMeals();

  //get selected treats
  let treats = $('.treat-meals .is-selected');

  if (treats.length) {
    treats.each(function (index, treat) {
      let id = treat.dataset.variantId;
      editCartQuantites[id] = 1;
      editTrialCartQuantites[id] = 1;
    });
  }

  let supplements = $('.supplement-meals .is-selected');
  let supplementCount = 1;

  if (supplements.length) {
    supplements.each(function (index, supplement) {
      let id = supplement.dataset.variantId;
      editCartQuantites[id] = supplementCount;
      editTrialCartQuantites[id] = supplementCount;
    });
  }

  // Transforming the object to an array of items with id and quantity
  let itemsToAdd = Object.entries(trial ? editTrialCartQuantites : editCartQuantites)
    .map(([id, quantity]) => ({ id, quantity }))
    .filter(item => item.quantity > 0); // Filters out items with quantity 0

  const selectedPlan = $('input[name="box-plan"]:checked').val() || 'full plan';

  // Build half plan cart (same treats/supplements as full, but half meal quantities)
  const halfPlanEditCart = { ...editHalfCartQuantites };
  // Add treats to half plan
  treats.each(function (index, treat) {
    halfPlanEditCart[treat.dataset.variantId] = 1;
  });
  // Add supplements to half plan
  supplements.each(function (index, supplement) {
    halfPlanEditCart[supplement.dataset.variantId] = supplementCount;
  });

  addItemsToCart(itemsToAdd, editCartQuantites, halfPlanEditCart, selectedPlan);

});

//age input fields logic
document.addEventListener("DOMContentLoaded", function () {
  const ageGroupRadios = document.querySelectorAll('input[name="age_group"]');
  const inputYears = document.querySelector('input[name="years"]');
  const inputMonths = document.querySelector('input[name="months"]');
  const inputYearsContainer = document.getElementById("input_age_years");

  function toggleInputs() {
    const selectedAgeGroup = document.querySelector('input[name="age_group"]:checked').value;

    if (selectedAgeGroup === "Puppy") {
      // Show only Months input, hide Years input
      inputYearsContainer.style.display = "none";
      inputMonths.parentElement.style.display = "block";
      inputMonths.setAttribute("required", "required"); // Make Months mandatory
      inputYears.removeAttribute("required");
      inputYears.value = ""; // Clear Years input if not needed
      inputYears.dispatchEvent(new Event('change'));
    } else {
      // Show both inputs but make Years input mandatory
      inputYearsContainer.style.display = "block";
      inputMonths.parentElement.style.display = "block";
      inputYears.setAttribute("required", "required");
      inputMonths.removeAttribute("required"); // Months optional
      inputMonths.dispatchEvent(new Event('change'));
      //inputMonths.value = ""; // Clear Months input if not needed
    }
  }

  // Event listener for age group radio buttons
  ageGroupRadios.forEach((radio) =>
    radio.addEventListener("change", toggleInputs)
  );

  // Initial call to set up the correct state
  toggleInputs();
});


/* Handle referral code from cookie */
jQuery(document).ready(function ($) {
  function mbGetCookie(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : '';
  }


  var discountCode = mbGetCookie('discount_code');
  if (typeof discountCode != 'undefined' && discountCode != '') {
    jQuery('#discount_code').val(discountCode);
  }

  handleCoupon();
});


//handle breed logic
const purebredRadio = document.getElementById('purebred');
const crossbreedRadio = document.getElementById('crossbreed');
const breedInput = document.getElementById('breed__autocomplete');

// Function to handle changes in radio selection
function handleRadioChange() {
  if (purebredRadio.checked) {
    breedInput.setAttribute('required', 'required');
    breedInput.value = ''; // Clear the input for manual entry
  } else if (crossbreedRadio.checked) {
    breedInput.removeAttribute('required');
    breedInput.value = 'Pawfect mix'; // Automatically fill with default text
  }
}

// Attach event listeners to radio buttons
purebredRadio.addEventListener('change', handleRadioChange);
crossbreedRadio.addEventListener('change', handleRadioChange);

// Call the function once on page load to set initial state
handleRadioChange();


let previousQuizData = localStorage.getItem("quizAnswers");
let previouslyStarted = false;
if (previousQuizData) {
  previouslyStarted = true;
  //show notification modal    
  document.querySelector('.quiz-started-overlay').classList.add('show-modal');
}

function prepopulateQuizData(previousQuizData) {

  let currentDogData = JSON.parse(previousQuizData);

  //update spayed/neutered label by gender
  let gender = currentDogData.gender;
  if (gender) {
    let label = document.getElementById('neutered-spayed');
    let old = label.innerHTML;
    label.innerHTML = (gender == 'Boy') ? old.replace('Spayed', 'Neutered') : old.replace('Neutered', 'Spayed');
    document.querySelector(`input[name="gender"][value="${gender.charAt(0).toUpperCase() + gender.slice(1)}"]`).checked = true;
  }

  // fill quiz data values

  //name
  let name = currentDogData.name;
  if (name) {
    document.querySelector('input[data-order="name"]').value = name;
    updateName();
  }

  //age
  let months = (currentDogData.months) ? currentDogData.months : 0;
  let years = (currentDogData.years) ? currentDogData.years : 0;
  document.querySelector(`input[name="months"]`).value = months;
  document.querySelector(`input[name="years"]`).value = years;

  let totalMonths = (years * 12) + months;

  if (totalMonths > 84) {
    document.querySelector(`input[name="age_group"][value="Senior"]`).checked = true;
    document.querySelector(`input[name="age_group"][value="Adult"]`).disabled = true;
    document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    // toggleInputs();
  } else if (totalMonths < 12) {
    document.querySelector(`input[name="age_group"][value="Puppy"]`).checked = true;
    // toggleInputs();
  } else {
    document.querySelector(`input[name="age_group"][value="Adult"]`).checked = true;
    document.querySelector(`input[name="age_group"][value="Puppy"]`).disabled = true;
    // toggleInputs();
  }

  //breed
  let breed = currentDogData.breed;

  if (breed != "") {
    const crossbreedRadio = document.getElementById('crossbreed');
    const purebredRadio = document.getElementById('purebred');
    let breedInput = document.querySelector('input[name="breed__autocomplete"]');

    if (breed == "Pawfect mix") {
      // If x is empty, select "crossbreed"
      crossbreedRadio.checked = true;
      breedInput.value = 'Pawfect mix'; // Clear input in case it's populated
    } else {
      // If x has a value, select "purebred" and set the input value
      purebredRadio.checked = true;
      console.log(breed);
      setTimeout(() => {
        breedInput.value = breed;
      }, 1000);
    }
  }




  //weight
  let weight = currentDogData.weight;
  document.getElementById('weightTextInput').value = weight;
  document.getElementById('weightRangeInput').value = weight;
  syncWeightInputs('weightTextInput', 'weightRangeInput');

  //spayed/neutered
  let spayed = currentDogData.neutered;
  if (spayed) {
    document.querySelector(`input[name="neutered"][value="${spayed}"]`).checked = true;
  }

  //bodytype
  let weightgroup = currentDogData.weightgroup;
  if (weightgroup) {
    document.querySelector(`input[name="weightgroup"][value="${weightgroup}"]`).checked = true;
  }

  //activity
  let activity = currentDogData.weightgroup;
  if (activity) {
    document.querySelector(`input[name="activity"][value="${activity}"]`).checked = true;
  }

  //allergies
  let allergies = currentDogData.allergies;
  if (allergies.length) {
    allergies.forEach((allergy, index) => {
      let capitalizedText = allergy.charAt(0).toUpperCase() + allergy.slice(1);
      document.querySelector(`input[name="allergies"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
  }

  //current diet
  let foodTypes = currentDogData.food;
  if (foodTypes.length) {
    foodTypes.forEach((foodType, index) => {
      let capitalizedText = foodType.charAt(0).toUpperCase() + foodType.slice(1);
      document.querySelector(`input[name="current__food"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
  }

  //treats
  let treats = currentDogData.treats;
  if (treats) {
    document.querySelector(`input[name="treats"][value="${treats}"]`).checked = true;
  }

  //prefferad treats
  let prefferedTreats = currentDogData.prefered_treat;
  if (prefferedTreats.length) {
    prefferedTreats.forEach((prefferedTreat, index) => {
      let capitalizedText = prefferedTreat.charAt(0).toUpperCase() + prefferedTreat.slice(1);
      document.querySelector(`input[name="prefered_treat"][type="checkbox"][value="${prefferedTreat}"]`).checked = true;
    });
  }

  //health issues
  let healthIssues = currentDogData.health_issues;
  if (healthIssues.length) {
    healthIssues.forEach((healthIssue, index) => {
      let capitalizedText = healthIssue.charAt(0).toUpperCase() + healthIssue.slice(1);
      document.querySelector(`input[name="health_issues"][type="checkbox"][value="${capitalizedText}"]`).checked = true;
    });
  }

  //fussy dog
  let fussy = currentDogData.fussy_dog;
  if (fussy) {
    document.querySelector(`input[name="fussy_dog"][value="${fussy}"]`).checked = true;
  }

  if (currentDogData.step) {
    step = currentDogData.step;
    if (step >= 16) {
      step = 15;
    }
    let progress_steps = document.querySelectorAll('.progress__step');
    progress_steps.forEach((progress_step) => {
      if (Number(progress_step.dataset.step) < step) {
        progress_step.classList.remove('is-active');
        progress_step.classList.add('is-complete');
      }
    });
    document.querySelector('.navigation__button.start__button').click();
  }

  let discountCode = currentDogData.discount_code;
  if (discountCode) {
    document.querySelector('#discount_code').value = discountCode;
    handleCoupon();
  }

  let customerEmail = currentDogData.customer_email;
  if (customerEmail) {
    document.querySelector('input[name="owner_email').value = customerEmail;
  }

  $('.apply-coupon').click();
  setTimeout(() => {
    calculateMealPlan(JSON.stringify(getInput()));
  }, 1000);


}


function saveQuizProgress(step) {
  let existingData = localStorage.getItem("quizAnswers");

  // Parse the data if it exists, or start with an empty object
  existingData = existingData ? JSON.parse(existingData) : {};

  // Get the new input data
  let newData = getInput();

  // Add/Update the step field
  newData.step = step;

  newData.discount_code = document.querySelector('#discount_code').value;
  newData.customer_email = document.querySelector('input[name="owner_email"]').value;
  newData.accepts_newsletter = document.querySelector('input[name="mc_signup"]').checked;

  // Merge the new data into the existing data
  const updatedData = { ...existingData, ...newData };

  // Save the updated data back to localStorage
  localStorage.setItem("quizAnswers", JSON.stringify(updatedData));
}

document.querySelector('.continue-quiz').addEventListener('click', function () {
  emptyCartOnStart();
  let stepToProceed = JSON.parse(localStorage.getItem("quizAnswers")).step;

  prepopulateQuizData(previousQuizData);
  setTimeout(() => {
    document.querySelector('.quiz-started-overlay').classList.remove('show-modal');
  }, 400);
});

document.querySelector('.restart-quiz').addEventListener('click', function () {
  localStorage.removeItem("quizAnswers");
  document.querySelector('.quiz-started-overlay').classList.remove('show-modal');
});

//prevent alert box on reload...
window.onbeforeunload = null;